/**
 * Stable partition: items matching the predicate move to the bottom while
 * preserving relative order within both groups.
 */
export function sortItemsToBottom<T>(
  items: Array<T>,
  shouldSinkToBottom: (item: T) => boolean,
) {
  const topItems = items.filter((item) => {
    return !shouldSinkToBottom(item)
  })
  const bottomItems = items.filter(shouldSinkToBottom)
  return [...topItems, ...bottomItems]
}

export function areArraysEqual<T>(a: Array<T>, b: Array<T>) {
  if (a === b) {
    // referential equality
    return true
  }

  if (a.length !== b.length) {
    return false
  }

  return a.every((item, index) => {
    return item === b[index]
  })
}
